module.exports = __webpack_public_path__ + "static/kpf_logo-dd387303786c501749fb7ba5978e6d1a.jpeg";